import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  Button,
  Card,
  CardContent,
  Collapse,
  Switch,
  TextField,
  Typography,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  TableRow,
  TableCell,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./subscriptions.module.css";
import SearchIcon from "@mui/icons-material/Search";
import { useLocalStorage } from "@uidotdev/usehooks";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import Sidebar from "../sidenav/Sidenav";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { hasStoredTabAccess } from '../utils/access';

const SubscriptionsMobile = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const [openSpecDialog, setOpenSpecDialog] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedSpecs, setSelectedSpecs] = useState([]);
  const [changedSkills, setChangedSkills] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [filteredSpecs, setFilteredSpecs] = useState([]);
  const [specSearchQuery, setSpecSearchQuery] = useState("");
  const [specLoading, setSpecLoading] = useState(false);
  const [specError, setSpecError] = useState("");
  const latestSpecFetchId = useRef(0);
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [actionType, setActionType] = useState("skills");
  const [searchQuery, setSearchQuery] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage("token", null);
  const [skillsCompletion, setSkillsCompletion] = useState([]);
  const isAuthorized = hasStoredTabAccess('Subscriptions');
  const canUpdateUser = isAuthorized;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedUsers = filteredUsers.slice(startIndex, endIndex);
  const [selectedDays, setSelectedDays] = useState(7); // default duration for specialization access
  const [openEditDateDialog, setOpenEditDateDialog] = useState(false);
  const [editTargetSpecId, setEditTargetSpecId] = useState(null);
  const [editMode, setEditMode] = useState("ADD_DAYS");
  const [editDays, setEditDays] = useState("");
  const [editTargetDate, setEditTargetDate] = useState("");

  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    referredBy: "",
    subscription_type: "free",
    communicationLanguage: "hi",
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleUpdate = async (userId) => {
    if (!canUpdateUser) return;

    const selected = users.find((user) => user.user_id === userId);
    console.log(selected);

    setSelectedUser(selected);

    let communicationLanguage = "hi";
    try {
      const prefResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user-preferences/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      communicationLanguage = prefResponse.data?.communicationLanguage || "hi";
    } catch (error) {
      console.error("Error fetching user preferences:", error);
    }

    setFormValues({
      id: selected.user_id,
      name: selected.name,
      email: selected.email,
      mobile: selected.mobile,
      referredBy: selected.referred_id,
      subscription_type: selected.subscription_type || "free",
      communicationLanguage,
    });
    setUpdateDialog(true);
  };

  const [updateDialog, setUpdateDialog] = useState(false);
  const handleUpdateDialogClose = () => {
    setUpdateDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleUpdateUser = async (id) => {
    if (!canUpdateUser) return;

    const { name, email, mobile, referredBy, subscription_type, communicationLanguage } = formValues;
    console.log(formValues);

    if (!name || !email || !mobile) {
      console.error("All fields are required");
      toast.error("All fields are required");
      return;
    }

    const validSubscriptionTypes = ["free", "paid"];
    if (!validSubscriptionTypes.includes(subscription_type)) {
      toast.error("Invalid subscription type");
      return;
    }

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/updateUser/update/${id}`,
        {
          name,
          email,
          mobile,
          referredBy,
          subscription_type,
          communication_language: communicationLanguage,
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("User data updated successfully");
        fetchUsers();
        setUpdateDialog(false);
      } else {
        toast.error("Error updating user data: ", response.data.message);
      }
    } catch (error) {
      toast.error("Error updating user data: ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user/all?order=desc`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const reversedUsers = response.data.data.reverse();
        setUsers(reversedUsers);
        setFilteredUsers(reversedUsers);
      } else {
        console.error("Error fetching users: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching users: ", error);
    }
  };

  const fetchCompletionData = async (userId, token) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user/${userId}/skillCompletion`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching skills completion data: ", error);
      return null;
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchCompletionData(token);
  }, [token]);

  const handleOpenDialog = async (userId, action) => {
    console.log("action ", action);
    try {
      if (action === "skills") {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/skill-data/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.data);
        const fetchedSkills = response.data.data;
        const sSkills = fetchedSkills?.map((val) =>
          val.is_active === null ? false : val.is_active === 0 ? false : true
        );
        console.log(sSkills);
        const selected = users.find((user) => user.user_id === userId);

        setSelectedUser(selected);
        setSelectedSkills(sSkills);
        setFilteredSkills(fetchedSkills);
        const completionData = await fetchCompletionData(userId, token);

        console.log(completionData !== null || completionData.length !== 0);
        if (completionData !== null) {
          setSkillsCompletion(completionData);
          setOpenDialog(true);
        } else {
          throw new Error("Failed to fetch skills completion data.");
        }
      } else if (action === "specs") {
        setSpecSearchQuery("");
        setSpecError("");
        setSpecLoading(true);
        setFilteredSpecs([]);
        setSelectedSpecs([]);
        setOpenSpecDialog(true);
      }
      setSelectedUserId(userId);
      setActionType(action);
    } catch (error) {
      console.error(
        "Error opening dialog and fetching completion data: ",
        error
      );
      toast.error(
        "An error occurred while opening the dialog.",
        error.toString()
      );
    }
  };
  console.log(changedSkills);
  const handleUnsubscription = () => {
    if (actionType === "update") {
      updateSkillStatus(changedSkills, 0);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenSpecDialog(false);
    setOpenEditDateDialog(false);
    setSelectedUserId(null);
    setSelectedSkills([]);
    setFilteredSkills([]);
    setFilteredSpecs([]);
    setSpecSearchQuery("");
    setSpecError("");
    setSpecLoading(false);
    latestSpecFetchId.current += 1;
    setSelectedSpecs([]);
    setChangedSkills([]);
    setEditTargetSpecId(null);
    setEditDays("");
    setEditTargetDate("");
  };

  const handleButtonClick = (userId, action) => {
    handleOpenDialog(userId, action);
  };

  const handleResetButtonClick = (userId) => {
    const apiUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/change-password/${userId}/resetLimit`;

    axios
      .put(apiUrl)
      .then((response) => {
        console.log(response.data.message);
        toast.success("User limit has been reset successfully.");
      })
      .catch((error) => {
        console.error("Error occurred: ", error);
        toast.error(
          error.response?.data?.message ||
            "An error occurred. Please try again later."
        );
      });
  };

  const handleSkillToggle = (e, skillId, ind) => {
    console.log(e.target.checked, skillId, ind, " Skill Toggle");
    console.log(selectedSkills);

    setSelectedSkills((prevSkills) => {
      const newSkills = [...prevSkills];
      newSkills[ind] = !newSkills[ind];

      return newSkills;
    });
  };

  const handleSpecToggle = (e, skillId, ind) => {
    console.log(e.target.checked, skillId, ind);
    console.log(selectedSkills);

    setSelectedSpecs((prevSpecs) => {
      const newSpecs = [...prevSpecs];
      newSpecs[ind] = !newSpecs[ind];

      return newSpecs;
    });
  };

  const refreshSpecData = useCallback(async (userId, searchValue = "") => {
    const fetchId = latestSpecFetchId.current + 1;
    latestSpecFetchId.current = fetchId;
    const trimmedSearch = searchValue.trim();
    const searchQuery = trimmedSearch
      ? `?search=${encodeURIComponent(trimmedSearch)}`
      : "";

    setSpecLoading(true);
    setSpecError("");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/spec-data/${userId}${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (fetchId !== latestSpecFetchId.current) {
        return;
      }

      const fetchedSpecs = response.data.data || [];
      const sSpecs = fetchedSpecs?.map((val) =>
        val.is_active === null ? false : val.is_active === 0 ? false : true
      );
      setSelectedSpecs(sSpecs);
      setFilteredSpecs(fetchedSpecs);
    } catch (error) {
      if (fetchId !== latestSpecFetchId.current) {
        return;
      }

      console.error("Error fetching specialization subscription data:", error);
      setFilteredSpecs([]);
      setSelectedSpecs([]);
      setSpecError(
        error.response?.data?.message ||
          "Error fetching specialization subscription data"
      );
    } finally {
      if (fetchId === latestSpecFetchId.current) {
        setSpecLoading(false);
      }
    }
  }, [token]);

  useEffect(() => {
    if (!openSpecDialog || actionType !== "specs" || !selectedUserId) {
      return;
    }

    const debounceTimer = setTimeout(() => {
      refreshSpecData(selectedUserId, specSearchQuery);
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [
    actionType,
    openSpecDialog,
    refreshSpecData,
    selectedUserId,
    specSearchQuery,
  ]);

  const handleOpenEditDate = (specializationId) => {
    setEditTargetSpecId(specializationId);
    setEditMode("ADD_DAYS");
    setEditDays("");
    setEditTargetDate("");
    setOpenEditDateDialog(true);
  };

  const handleCloseEditDate = () => {
    setOpenEditDateDialog(false);
    setEditTargetSpecId(null);
    setEditDays("");
    setEditTargetDate("");
  };

  const handleUpdateSubscriptionEndDate = async () => {
    if (!selectedUserId || !editTargetSpecId) {
      toast.error("User or specialization not selected");
      return;
    }

    if (editMode === "ADD_DAYS") {
      const days = Number(editDays);
      if (!Number.isInteger(days) || days <= 0) {
        toast.error("Days must be a positive integer");
        return;
      }
    }

    if (editMode === "SET_DATE" && !editTargetDate) {
      toast.error("Target date is required");
      return;
    }

    const payload = {
      userId: selectedUserId,
      targetType: "SPECIALIZATION",
      specializationId: editTargetSpecId,
      updateType: editMode,
      ...(editMode === "ADD_DAYS"
        ? { days: Number(editDays) }
        : { targetDate: editTargetDate }),
    };

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/update-end-date`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response?.data?.message || "End date updated successfully");
      await refreshSpecData(selectedUserId, specSearchQuery);
      handleCloseEditDate();
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Error updating subscription end date"
      );
    }
  };

  const updateSkillStatus = (skillId, isActive) => {
    if (skillId.length === 0) {
      toast.error("No skill selected");
      return;
    }
    const data = {
      user_id: selectedUserId,
      skill_id: skillId,
      is_active: isActive,
    };

    axios
      .put(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/enrollment/updateStatus`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("User Unsubscribed successfully");
        setOpenDialog(false);
        console.log("Status update success:", response.data);
      })
      .catch((error) => {
        toast.error("Update Failed.");
        console.error("Status update error:", error);
      });
  };

  const handleSubscription = async () => {
    setOpenDialog(false);
    const skillsToInsert = filteredSkills
      .filter((skill, index) => {
        if (skill.is_active === null && selectedSkills[index] === true) {
          return true;
        }
        return false;
      })
      ?.map((val) => {
        return {
          skillId: val.skill_id,
          isActive: true,
        };
      });

    const skillsToUpdate = filteredSkills
      ?.map((skill, index) => {
        if (
          skill.is_active !== null &&
          skill.is_active != selectedSkills[index]
        ) {
          return {
            skillId: skill.skill_id,
            isActive: selectedSkills[index],
          };
        }
      })
      .filter((val) => val !== undefined);

    if (actionType == "skills") {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/skill-subscription`,
          {
            skillsToInsert: skillsToInsert || [],
            skillsToUpdate: skillsToUpdate || [],
            userId: selectedUserId,
          }
        );

        if (response.status === 200) {
          toast.success("Skills Updated Successfully");
        }
      } catch (error) {
        toast.error("error Updating skills Status");
        console.error(error);
      }
    }
  };

  const handleSpecSubscription = async () => {
    setOpenSpecDialog(false);
    const specToInsert = filteredSpecs
      .filter((spec, index) => {
        if (spec.is_active === null && selectedSpecs[index] === true) {
          return true;
        }
        return false;
      })
      ?.map((val) => {
        return {
          specId: val.specialization_id,
          isActive: true,
        };
      });

    const specsToUpdate = filteredSpecs
      ?.map((spec, index) => {
        if (spec.is_active !== null && spec.is_active != selectedSpecs[index]) {
          return {
            specId: spec.specialization_id,
            isActive: selectedSpecs[index],
          };
        }
      })
      .filter((val) => val !== undefined);

    const finalArray = specToInsert.concat(specsToUpdate);

    if (actionType == "specs") {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/subscription/specialization-subscription`,
          {
            specArray: finalArray,
            durationDays: selectedDays, // pass selected duration to backend
            userId: selectedUserId,
          }
        );

        if (response.status === 200) {
          toast.success("Specialization Updated Successfully");
        }
      } catch (error) {
        toast.error("error Updating Specialization Status");
        console.error(error);
      }
    }
  };

  const filterUsers = (query) => {
    if (!query) {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(
        (user) =>
          user.name.toLowerCase().includes(query.toLowerCase()) ||
          user.username.toLowerCase().includes(query.toLowerCase()) ||
          user.email.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  };

  useEffect(() => {
    filterUsers(searchQuery);
  }, [searchQuery]);

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "5%" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }

  function formatDate(date) {
    date = new Date(date);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let formattedDate = `${day}.${month}.${year}`;
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let AmOrPm = hours >= 12 ? "pm" : "am";
    let formattedTime = `${hours}:${minutes}${AmOrPm}`;
    return { time: formattedTime, date: formattedDate };
  }

  function formatSkillEndDate(dateTimeString) {
    if (!dateTimeString) {
      return "-";
    }
    const date = new Date(dateTimeString);
    if (Number.isNaN(date.getTime())) {
      return "-";
    }
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow>
          <TableCell style={{ maxWidth: "20ch", wordWrap: "break-word" }}>
            <div>{row?.name}</div>
            <div>{row?.username}</div>
            <div>Class: {row?.user_class || "Not Added"}</div>
          </TableCell>
          <TableCell align="right">
            <div>{formatDate(row?.created_at).date}</div>
            <div>{formatDate(row?.created_at).time}</div>
          </TableCell>
          <TableCell>
            <IconButton
              aria-label="expand row"
              style={{ color: "black" }}
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow
          sx={{
            "& td": { border: 0, height: open ? "auto" : 0 },
            borderBottom: "1px solid black",
          }}
        >
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderTop: "none" }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 150px",
                  rowGap: "6px",
                  fontSize: "10px",
                  marginTop: "4px",
                  marginBottom: "4px",
                }}
              >
                <div>Email: {row?.email}</div>
                <div>Mobile: {row?.mobile}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "10px",
                  marginBottom: "5px",
                }}
              >
                <div style={{ marginRight: "0.5rem" }}>Action:</div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "end",
                    gap: "9px",
                    flex: "1",
                  }}
                >
                  <Button
                    onClick={() => handleButtonClick(row.user_id, "specs")}
                    className={styles.actionBtn}
                    style={{
                      backgroundColor: "#FFD6D2",
                    }}
                  >
                    Specialization
                  </Button>
                  <Button
                    onClick={() => handleButtonClick(row.user_id, "skills")}
                    className={styles.actionBtn}
                    style={{
                      backgroundColor: "#D1F4DE",
                    }}
                  >
                    Skills
                  </Button>
                  <Button
                    onClick={() => handleResetButtonClick(row.user_id)}
                    className={styles.actionBtn}
                    style={{
                      backgroundColor: "#FCF6BC",
                      padding: "0",
                    }}
                  >
                    Reset Limits
                  </Button>
                  {canUpdateUser && (
                    <Button
                      onClick={() => {
                        handleUpdate(row.user_id);
                      }}
                      className={styles.actionBtn}
                      style={{
                        backgroundColor: "#CBEBF6",
                      }}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0.75rem 1.25rem 0.75rem",
        }}
      >
        <div
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "36px",
            height: "36px",
            borderRadius: "18px",
            background: "#EAF1F7",
          }}
        >
          <Hemberger />
        </div>
        <Link to="/profile">
          <UserIcon />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      <Card style={{ boxShadow: "none", padding: "0" }}>
        <CardContent style={{ padding: "0" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "0rem 0.75rem 1.5rem 0.75rem",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  navigate("/dashboard");
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
                Subscriptions
              </h4>
            </div>
            <TextField
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                    boxShadow: "none",
                  },
                },
              }}
              InputProps={{
                style: {
                  height: "1.75rem",
                  width: "9.75rem",
                  boxShadow:
                    "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                  padding: "0",
                },
                endAdornment: (
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </div>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              "& .MuiTablePagination-input": {
                marginRight: "0.5rem",
                marginLeft: "0",
              },
            }}
          />
          <ToastContainer />

          {/* MUI Table */}
          <Table
            aria-label="collapsible table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <TableHead
              style={{
                height: "2.564vw",
                borderRadius: "4px !important",
                background: "rgba(234, 241, 247, 1)",
                boxShadow: "2px 2px 4px 0px rgba(174, 174, 192, 0.5)",
              }}
            >
              <TableRow>
                <TableCell>Name & Username</TableCell>
                <TableCell align="right">Date & Time</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedUsers?.map((user, ind) => (
                <Row key={ind} row={user} />
              ))}
            </TableBody>

            {/* Skills Dialog */}
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              PaperProps={{
                style: {
                  padding: "1.5rem",
                  borderRadius: "0.3rem",
                  boxShadow:
                    "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
                  overflowX: "hidden",
                },
              }}
            >
              <DialogTitle
                style={{ paddingLeft: "0", fontWeight: "600", paddingTop: "0" }}
              >
                Student Skill Management
              </DialogTitle>
              <div className="dialog-content">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: "1.282vw",
                  }}
                >
                  <div style={{ fontSize: "0.75rem", fontWeight: "500" }}>
                    Name: {selectedUser.name}
                  </div>
                  <div style={{ fontSize: "0.75rem", fontWeight: "500" }}>
                    Username: {selectedUser.username}
                  </div>
                </div>
                <table className="table">
                  <thead className={styles.dialogTableHead}>
                    <tr>
                      <th style={{ textAlign: "left", fontSize: "0.75rem" }}>
                        Skill Name
                      </th>
                      <th style={{ fontSize: "0.75rem" }}>Completion %</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSkills?.map((skill, index) => (
                      <tr key={skill.skill_id}>
                        <td style={{ textAlign: "left" }}>
                          {skill.skill_name}
                        </td>
                        <td>
                          <Typography style={{ fontSize: "0.8125rem" }}>
                            {Math.floor(
                              skillsCompletion.find(
                                (completion) =>
                                  completion.skill_id === skill.skill_id
                              )?.completion_percentage || 0
                            )}
                            %
                          </Typography>
                        </td>
                        <td>
                          <Switch
                            value={skill.skill_id}
                            onChange={(e) =>
                              handleSkillToggle(e, skill.skill_id, index)
                            }
                            checked={selectedSkills[index]}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {actionType === "skills" && (
                <div className={styles.buttonContainer}>
                  <Button
                    onClick={handleCloseDialog}
                    className="formBtnMobile"
                    style={{
                      color: "black",
                      border: "2px solid #313C63",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubscription}
                    className="formBtnMobile"
                    style={{
                      backgroundColor: "#37446F",
                      color: "white",
                    }}
                  >
                    Update Skills
                  </Button>
                </div>
              )}
              {actionType === "update" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    onClick={handleCloseDialog}
                    className="formBtnMobile"
                    style={{
                      border: "2px solid #313C63",
                      color: "#000000",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleUnsubscription}
                    className="formBtnMobile"
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#37446F",
                    }}
                  >
                    Unsubscribe
                  </Button>
                </div>
              )}
            </Dialog>

            {/* Specialization Dialog */}
            <Dialog
              open={openSpecDialog}
              onClose={handleCloseDialog}
              PaperProps={{
                style: {
                  padding: "1.5rem",
                  borderRadius: "0.3rem",
                  boxShadow:
                    "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
                },
              }}
            >
              <DialogTitle
                style={{ paddingLeft: "0", fontWeight: "600", paddingTop: "0" }}
              >
                Add Specialization
              </DialogTitle>
              <div className="dialog-content">
                <div
                  style={{ display: "flex", gap: "0.75rem", marginBottom: "0.75rem" }}
                >
                  <FormControl size="small" fullWidth>
                    <InputLabel id="duration-label">
                      Access Duration (days)
                    </InputLabel>
                    <Select
                      labelId="duration-label"
                      label="Access Duration (days)"
                      value={selectedDays}
                      onChange={(e) => setSelectedDays(Number(e.target.value))}
                    >
                      {[1, 3, 7, 15, 30, 90, 365].map((d) => (
                        <MenuItem key={d} value={d}>
                          {d}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <TextField
                  label="Search specializations"
                  value={specSearchQuery}
                  onChange={(e) => setSpecSearchQuery(e.target.value)}
                  size="small"
                  fullWidth
                  className="customTextfieldMobile"
                  style={{ marginBottom: "0.75rem" }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "transparent",
                      },
                    },
                  }}
                />
                <table className="table">
                  <thead className={styles.dialogTableHead}>
                    <tr>
                      <th style={{ textAlign: "left", fontSize: "0.75rem" }}>
                        Specialization Name
                      </th>
                      <th style={{ fontSize: "0.75rem" }}>Toggle</th>
                      <th style={{ fontSize: "0.75rem" }}>Edit Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specLoading ? (
                      <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                          Loading...
                        </td>
                      </tr>
                    ) : specError ? (
                      <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                          {specError}
                        </td>
                      </tr>
                    ) : filteredSpecs.length === 0 ? (
                      <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                          No specializations found
                        </td>
                      </tr>
                    ) : (
                      filteredSpecs?.map((spec, index) => (
                        <tr key={spec.specialization_id}>
                          <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                            {spec.specialization_name}
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <Switch
                              value={spec.specialization_id}
                              onChange={(e) =>
                                handleSpecToggle(e, spec.specialization_id, index)
                              }
                              checked={selectedSpecs[index]}
                            />
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <Button
                              variant="contained"
                              onClick={() =>
                                handleOpenEditDate(spec.specialization_id)
                              }
                              style={{
                                textTransform: "capitalize",
                                minWidth: "unset",
                                padding: "0.2rem 0.45rem",
                                fontSize: "0.7rem",
                                whiteSpace: "nowrap",
                                borderRadius: "4px",
                                backgroundColor: "#37446F",
                                color: "#ffffff",
                              }}
                            >
                              Edit Date
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className={styles.buttonContainer}>
                <Button
                  onClick={handleCloseDialog}
                  className="formBtnMobile"
                  style={{
                    border: "2px solid #313C63",
                    color: "#000000",
                    flex: "1",
                    fontsize: "0.75rem !important",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSpecSubscription}
                  className="formBtnMobile"
                  style={{
                    backgroundColor: "#37446F",
                    color: "white",
                    fontsize: "0.75rem !important",
                  }}
                >
                  Update Specialization
                </Button>
              </div>
            </Dialog>

            <Dialog
              open={openEditDateDialog}
              onClose={handleCloseEditDate}
              fullWidth
              PaperProps={{
                style: {
                  margin: 0,
                  width: "100%",
                  maxWidth: "100%",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  borderBottomLeftRadius: "0",
                  borderBottomRightRadius: "0",
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: "1rem",
                },
              }}
            >
              <DialogTitle
                style={{ paddingLeft: "0", fontWeight: "600", paddingTop: "0" }}
              >
                Edit End Date
              </DialogTitle>
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "#4D4D4D",
                  marginBottom: "0.6rem",
                }}
              >
                Current Expiry:{" "}
                {formatSkillEndDate(
                  filteredSpecs.find(
                    (spec) => spec.specialization_id === editTargetSpecId
                  )?.skillEndDate
                )}
              </div>
              <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.75rem" }}>
                <Button
                  variant={editMode === "ADD_DAYS" ? "contained" : "outlined"}
                  onClick={() => setEditMode("ADD_DAYS")}
                  style={{ textTransform: "capitalize", flex: 1 }}
                >
                  Add Days
                </Button>
                <Button
                  variant={editMode === "SET_DATE" ? "contained" : "outlined"}
                  onClick={() => setEditMode("SET_DATE")}
                  style={{ textTransform: "capitalize", flex: 1 }}
                >
                  Pick Date
                </Button>
              </div>
              {editMode === "ADD_DAYS" ? (
                <TextField
                  fullWidth
                  type="number"
                  label="Days"
                  value={editDays}
                  onChange={(e) => setEditDays(e.target.value)}
                  inputProps={{ min: 1, step: 1 }}
                />
              ) : (
                <TextField
                  fullWidth
                  type="date"
                  label="Target Date"
                  value={editTargetDate}
                  onChange={(e) => setEditTargetDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              <div className={styles.buttonContainer} style={{ marginTop: "0.75rem" }}>
                <Button
                  onClick={handleCloseEditDate}
                  className="formBtnMobile"
                  style={{ border: "2px solid #313C63", color: "#000000" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleUpdateSubscriptionEndDate}
                  className="formBtnMobile"
                  style={{ backgroundColor: "#37446F", color: "#ffffff" }}
                >
                  Update Date
                </Button>
              </div>
            </Dialog>

            {/* Update User Details */}
            <Dialog open={updateDialog} onClose={handleUpdateDialogClose}>
              <DialogTitle>Update User Details</DialogTitle>
              <form
                className="m-2"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "4px",
                }}
              >
                <TextField
                  type="text"
                  label="Name"
                  name="name"
                  variant="outlined"
                  value={formValues.name}
                  onChange={handleFormChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "transparent",
                        boxShadow: "none",
                      },
                    },
                    marginBottom: "1rem",
                  }}
                  InputLabelProps={{
                    sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                    required: false,
                  }}
                  InputProps={{
                    style: {
                      boxShadow:
                        "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                    },
                  }}
                />
                <TextField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "transparent",
                        boxShadow: "none",
                      },
                    },
                    marginBottom: "1rem",
                  }}
                  InputLabelProps={{
                    sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                    required: false,
                  }}
                  InputProps={{
                    style: {
                      boxShadow:
                        "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                    },
                  }}
                  type="email"
                  label="Email"
                  name="email"
                  value={formValues.email}
                  onChange={handleFormChange}
                />
                <TextField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "transparent",
                        boxShadow: "none",
                      },
                    },
                    marginBottom: "1rem",
                  }}
                  InputLabelProps={{
                    sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                    required: false,
                  }}
                  InputProps={{
                    style: {
                      boxShadow:
                        "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                    },
                  }}
                  type="phone"
                  label="mobile"
                  name="mobile"
                  value={formValues.mobile}
                  onChange={handleFormChange}
                />
                <TextField
                  type="text"
                  label="Referral Code"
                  name="referredBy"
                  variant="outlined"
                  value={formValues.referredBy}
                  onChange={handleFormChange}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "transparent",
                        boxShadow: "none",
                      },
                    },
                    marginBottom: "1rem",
                  }}
                  InputLabelProps={{
                    sx: { "&.Mui-focused": { color: "#A8A8A8" } },
                    required: false,
                  }}
                  InputProps={{
                    style: {
                      boxShadow:
                        "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
                    },
                  }}
                />
                <FormControl variant="outlined" sx={{ marginBottom: "1rem" }}>
                  <InputLabel>Subscription Type</InputLabel>
                  <Select
                    name="subscription_type"
                    value={formValues.subscription_type}
                    onChange={handleFormChange}
                    label="Subscription Type"
                  >
                    <MenuItem value="free">Free</MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                  </Select>
                </FormControl>
                <FormControl variant="outlined" sx={{ marginBottom: "1rem" }}>
                  <InputLabel>Communication Language</InputLabel>
                  <Select
                    name="communicationLanguage"
                    value={formValues.communicationLanguage}
                    onChange={handleFormChange}
                    label="Communication Language"
                  >
                    <MenuItem value="hi">Hindi</MenuItem>
                    <MenuItem value="en">English</MenuItem>
                  </Select>
                </FormControl>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    className="formBtnMobile"
                    onClick={handleUpdateDialogClose}
                    style={{
                      border: "2px solid #313C63",
                      color: "black",
                    }}
                  >
                    Cancel
                  </Button>
                  {canUpdateUser && (
                    <Button
                      className="formBtnMobile"
                      onClick={() => {
                        handleUpdateUser(formValues.id);
                      }}
                      style={{
                        backgroundColor: "#37446F",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </form>
            </Dialog>
          </Table>
        </CardContent>
      </Card>
    </>
  );
};

export default SubscriptionsMobile;
